var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "#FF3939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3939",
    fillRule: "nonzero",
    d: "M28.985 28.278 39.263 18l.707.707-10.278 10.278L39.97 39.263l-.707.707-10.278-10.278L18.707 39.97 18 39.263l10.278-10.278L18 18.707l.707-.707z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIconRed);
export default __webpack_public_path__ + "static/media/invalid-icon-red.ef93ef02e5ebcb38c56ca2aa163bd1da.svg";
export { ForwardRef as ReactComponent };